//CREACION DE FUNCIONES PARA CALENDARIO MANUAL.
import { dayNames, TALLER_SEPARATOR } from '../consts'

export const getNumberOfDaysInMonth = (year, month ) =>{
    return new Date(year, month+1,0).getDate();
}

export const getSortedDays = (year, month) =>{
    const dayIndex = new Date(year,month,1).getDay();
    const firstHalf = dayNames.slice(dayIndex);
    return [...firstHalf, ...dayNames.slice(0,dayIndex)];
};

export const range = (start,end) =>{
    const length = Math.abs((end-start)/1);
    
    const {result} = Array.from({length}).reduce(
        ({result, current })=>({
            result:[...result,current],
            current:current+1,
        }),
        {result:[], current:start}
    );
    return result;
}

// --- Utilidades para talleres múltiples en un Pedido ---
// Convierte el valor del campo `taller` (string con separador) a un arreglo de nombres.
export const splitTalleres = (value) => {
    if (!value) return [];
    return String(value)
        .split(TALLER_SEPARATOR)
        .map((nombre) => nombre.trim())
        .filter((nombre) => nombre.length > 0);
};

// Convierte un arreglo de nombres a un string unificado con el separador.
export const joinTalleres = (names) => {
    if (!Array.isArray(names)) return '';
    const clean = names
        .map((nombre) => String(nombre).trim())
        .filter((nombre) => nombre.length > 0);
    return clean.join(TALLER_SEPARATOR);
};

// Formato legible para mostrar en pantalla (por ejemplo, en los checklists).
export const formatTalleres = (value) => {
    return splitTalleres(value).join(', ');
};